// extracted by mini-css-extract-plugin
export var active = "HamburgerMenu-module--active--11e94";
export var btnsWrapper = "HamburgerMenu-module--btnsWrapper--cf69e";
export var category = "HamburgerMenu-module--category--f21fc";
export var categorySubTitle = "HamburgerMenu-module--categorySubTitle--78e53";
export var dropdownBtn = "HamburgerMenu-module--dropdownBtn--183ca";
export var dropdownContent = "HamburgerMenu-module--dropdownContent--12725";
export var hamburgerContent = "HamburgerMenu-module--hamburgerContent--02c50";
export var hamburgerWrapper = "HamburgerMenu-module--hamburgerWrapper--60f38";
export var navItems = "HamburgerMenu-module--navItems--5de0c";